import { render, staticRenderFns } from "./ForumsListWidget.vue?vue&type=template&id=3262e2ba"
import script from "./ForumsListWidget.vue?vue&type=script&lang=js"
export * from "./ForumsListWidget.vue?vue&type=script&lang=js"
import style0 from "./ForumsListWidget.vue?vue&type=style&index=0&id=3262e2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports